<template>
  <v-select
    v-model="input"
    :items="items"
    :dense="dense"
    :item-value="itemValue"
    item-text="name"
    outlined
    class="select-field"
    append-icon="mdi-chevron-down"
    @input="$emit('input', input)"
    @blur="$emit('blur')"
    v-bind="$attrs"
    :rules="getRules"
  >
    <template v-slot:selection="{ item, index }" v-if="isMultiple">
      <template v-if="isObject(item)">
        <template v-if="index === 0">{{ item.name }}</template>
        <span v-if="index === 1" class="grey--text caption">
          (+{{ value.length - 1 }} others)
        </span>
      </template>
      <template v-else>
        <template v-if="index === 0">{{ item }}</template>
        <span v-if="index === 1" class="grey--text caption">
          (+{{ value.length - 1 }} others)
        </span>
      </template>
    </template>
    <div slot="append" class="d-flex">
      <v-icon> mdi-chevron-down</v-icon>
      <v-tooltip bottom v-if="help">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" class="" x-small>
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ help }}</span>
      </v-tooltip>
    </div>
  </v-select>
</template>

<script>
import { getRules } from "../../../assets/js/common";
export default {
  props: {
    value: {
      type: [String, Array, Number, Boolean, Object],
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: "",
    },
    itemValue: {
      type: String,
      default: "value",
    },
    customRules: {
      type: Array,
      default: () => [],
    },
    help: String,
  },
  data() {
    return {
      input: "",
    };
  },
  computed: {
    getRules() {
      let { customRules, rules } = this;
      if (customRules.length > 0) return customRules;
      return getRules(rules);
    },
    isMultiple() {
      return this.input instanceof Array;
    },
  },
  watch: {
    value(val) {
      this.input = val;
    },
  },
  methods: {
    isObject(item) {
      return item instanceof Object;
    },
  },
  mounted() {
    this.input = this.value;
  },
};
</script>

<style></style>
